import { KnownMembership, MatrixClient } from 'matrix-js-sdk/src/matrix';

import { calculatePermissions } from 'hooks/useWorkspacePermissions/utils';

import { CustomMeedioMatrixEvents, MEEDIO_BOT_ID, hasMembership } from './matrixUtils';

export const isWorkspaceBotJoined = (matrixClient: MatrixClient, roomId: string): boolean => {
  const room = matrixClient.getRoom(roomId);
  if (!room || !MEEDIO_BOT_ID) return false;

  return hasMembership(room, MEEDIO_BOT_ID, KnownMembership.Join);
};

export const sendWorkspaceDeleteEvent = async (matrixClient: MatrixClient, roomId: string) => {
  const userId = matrixClient.getUserId();
  if (!userId) throw new Error('No authenticated user');

  const room = matrixClient.getRoom(roomId);
  if (!room) throw new Error(`Room ${roomId} not found`);

  if (!calculatePermissions(matrixClient, roomId).workspaceDelete) {
    throw new Error('Insufficient power level to delete workspace');
  }

  if (!isWorkspaceBotJoined(matrixClient, roomId)) {
    throw new Error('Bot is not present in the room. Cannot trigger deletion.');
  }

  await matrixClient.sendStateEvent(roomId, CustomMeedioMatrixEvents.WORKSPACE_DELETE, {
    requested_by: userId,
    requested_at: new Date().toISOString(),
  });
};
